import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// IMAGES IMPORTS
import contactLogo from "./../assets/AyurvedaAssets/images/logo.svg";

// Clients
import Client01 from "./../assets/AyurvedaAssets/images/client/client-01.png";
import Client02 from "./../assets/AyurvedaAssets/images/client/client-02.png";
import Client03 from "./../assets/AyurvedaAssets/images/client/client-03.png";
import Client04 from "./../assets/AyurvedaAssets/images/client/client-04.png";
import Client05 from "./../assets/AyurvedaAssets/images/client/client-05.png";

export default function Contact() {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: true, // whether animation should happen only once
    });

    let Clients = [Client01, Client02, Client03, Client04, Client05];
    setClients(Clients);
  }, []);

  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 4, arrows: false },
      },
      {
        breakpoint: 775,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 375,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="site-main">
      {/* contact-section */}
      <section className="prt-row contact-section01 clearfix">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 col-lg-12 m-auto">
              <div className="prt_contact_widget_wrapper">
                <div className="contact-logo-block">
                  <div>
                    <a
                      className="home-link"
                      href="index-2.html"
                      title="Medisat"
                      rel="home"
                    >
                      <img
                        height="200"
                        width="200"
                        className="img-fluid auto_size w-64 h-64"
                        src={contactLogo}
                        alt="logo-img"
                      />
                    </a>
                  </div>
                  <div>
                    <h3>
                      ayurveda
                      <br /> the since of life
                    </h3>
                  </div>
                </div>

                <div className="row align-items-center mt-45 res-767-mt-30">
                  {/* Address */}
                  <div className="col-lg-7 col-md-12">
                    <div className="prt-featured-block">
                      <div className="row g-0 row-equal-height overflow-hidden">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="featured-icon-box icon-align-before-content style4">
                            <div className="featured-icon">
                              <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                                <i className="flaticon flaticon-address"></i>
                              </div>
                            </div>
                            <div className="featured-content">
                              <div className="featured-title">
                                <h3>Address:</h3>
                              </div>
                              <div className="featured-desc">
                                <p>
                                  B-107 Awas Vikas Colony, Khatauli, District Muzaffar Nagar, UP -251201, India
                                  IN: +91-7060112355
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Hotlines */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="featured-icon-box icon-align-before-content style4 border-left">
                            <div className="featured-icon">
                              <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                                <i className="flaticon flaticon-call"></i>
                              </div>
                            </div>
                            <div className="featured-content">
                              <div className="featured-title">
                                <h3>Our hotlines:</h3>
                              </div>
                              <div className="featured-desc">
                                <div className="featured-list">
                                  Mobile :{" "}
                                  <span>
                                    <a href="tel:1234567890">
                                      +91-7060112355
                                    </a>
                                  </span>
                                </div>
                                <div className="featured-list">
                                  Phone :{" "}
                                  <span>
                                    <a href="tel:1234567890">+91-7060112355</a>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Email */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="featured-icon-box icon-align-before-content style4 border-top">
                            <div className="featured-icon">
                              <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                                <i className="flaticon flaticon-email"></i>
                              </div>
                            </div>
                            <div className="featured-content">
                              <div className="featured-title">
                                <h3>Email:</h3>
                              </div>
                              <div className="featured-desc featured-link">
                                <p>
                                  <a
                                    className="underline"
                                    href="mailto:bharatdharacares@gmail.com"
                                  >
                                    bharatdharacares@gmail.com
                                  </a>
                                  <br />
                                  <a href="bharatdharacares@gmail.com">
                                    bharatdharacares@gmail.com
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Social */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="featured-icon-box icon-align-before-content style4 border-top border-left">
                            <div className="featured-icon">
                              <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                                <i className="flaticon flaticon-worldwide"></i>
                              </div>
                            </div>
                            <div className="featured-content">
                              <div className="featured-title">
                                <h3>Social:</h3>
                              </div>
                              <div className="featured-desc">
                                <ul className="social-icons">
                                  <li>
                                    <a
                                      href="#"
                                      rel="noopener"
                                      aria-label="facebook"
                                    >
                                      <i className="fontello icon-facebook"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="#"
                                      rel="noopener"
                                      aria-label="twitter"
                                    >
                                      <i className="fontello icon-twitter"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="#"
                                      rel="noopener"
                                      aria-label="instagram"
                                    >
                                      <i className="fontello icon-instagram"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="#"
                                      rel="noopener"
                                      aria-label="pinterest"
                                    >
                                      <i className="fontello icon-pinterest"></i>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Working Hour */}
                  <div
                    className="col-lg-5 col-md-12"
                    data-aos="fade-left"
                    data-aos-duration="1000"
                  >
                    <div className="col-bg-img-five prt-bg prt-col-bgimage-yes bg-base-dark spacing-1 border-rad_10 res-991-mt-30">
                      <div className="prt-col-wrapper-bg-layer prt-bg-layer border-rad_10">
                        <div className="prt-col-wrapper-bg-layer-inner border-rad_10"></div>
                      </div>
                      <div className="layer-content text-start">
                        <div className="prt-contact-block1">
                          <h3>Working hour</h3>
                          <p className="prt-time">
                            Mon - Sat : 09 am to - 06 pm
                          </p>
                          <p className="text-base-skin">Sunday close</p>
                          <div className="mt-25">
                            <h3>Are you facing any problem?</h3>
                            <p className="text-base-white">
                              Get an Ayurvedic medical checkup
                            </p>
                            <div className="mt-25">
                              <a
                                className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-skincolor"
                                href="contact-us.html"
                              >
                                Get a appointment
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Rating */}
                <div className="row">
                  <div className="col-lg-12">
                    <div className="d-flex align-items-center justify-content-center mt-35 text-center">
                      <ul className="prt-list rating-star">
                        <li>
                          <i className="fa fa-star" aria-hidden="true"></i>
                        </li>
                        <li>
                          <i className="fa fa-star" aria-hidden="true"></i>
                        </li>
                        <li>
                          <i className="fa fa-star" aria-hidden="true"></i>
                        </li>
                        <li>
                          <i className="fa fa-star" aria-hidden="true"></i>
                        </li>
                        <li>
                          <i className="fa fa-star" aria-hidden="true"></i>
                        </li>
                      </ul>
                      <p className="mb-0">
                        <span className="headingfont-color"> 4.7/5.0 </span>
                        Trusted by over{" "}
                        <span className="text-base-dark fs-20 fw-600">
                          38k+
                        </span>{" "}
                        ambitious brands across the world
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Map */}
      <a
        href="https://www.google.com/maps/dir//BharatDhara+Natural+Farming+Producer+Company+Limited,+7P8J%2BQCW,+B+107,+Avas+Vikas+Colony,+Khatauli,+Khatauli+Rural,+Uttar+Pradesh+251201,+India/@29.267006,77.6897769,13z/data=!4m9!4m8!1m0!1m5!1m1!1s0x390c130049c2c69f:0xd0310dbded66d6f3!2m2!1d77.7310625!2d29.2669375!3e0?hl=en"
        target="_blank"
        rel="noopener noreferrer"
        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-skincolor"
      >
        📍 Get Directions to BharatDhara Khatauli
      </a>
      <div id="google_map" className="google_map">
        <div className="map_container">
          <div id="map">

            <iframe
              src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d3480.588862021581!2d77.72740311075825!3d29.26503500497525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e0!4m5!1s0x390c12882c8c4ec3%3A0x712d5b69b856ad9a!2sb%2C%207P8J%2BQCW%2C%20B%20107%2C%20Avas%20Vikas%20Colony%2C%20Khatauli%2C%20Khatauli%20Rural%2C%20Uttar%20Pradesh%20251201%2C%20India!3m2!1d29.266863299999997!2d77.73104839999999!4m5!1s0x390c12883d41b35f%3A0x13b7eef8286760c0!2sAvas%20Vikas%20Colony%2C%20Khatauli%20Rural%2C%20Khatauli%2C%20Uttar%20Pradesh%20251201%2C%20India!3m2!1d29.2628594!2d77.72947049999999!5e0!3m2!1sen!2sus!4v1762109505109!5m2!1sen!2sus"
              title="Google Map"
              style={{ border: 0, width: "100%", height: "400px" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Request a Quote */}
      <section className="prt-row padding_zero-section contact-section mt_120 res-991-mt-0 clearfix">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 col-lg-12 m-auto">
              <div className="prt-contactblock">
                <h3>Request a quote</h3>
                <p>
                  Your inquiries matter to us and please don't hesitate to reach
                  out today and let
                  <br /> begin a conversion leading you to the best solutions.
                </p>
                <form
                  action="#"
                  className="query_form-2 wrap-form clearfix mt-25"
                  method="post"
                >
                  <div className="row">
                    <div className="col-md-4">
                      <span className="text-input">
                        <input
                          name="name"
                          type="text"
                          placeholder="Your name"
                          required
                        />
                      </span>
                    </div>
                    <div className="col-md-4">
                      <span className="text-input">
                        <input
                          name="email"
                          type="text"
                          placeholder="Your email"
                          required
                        />
                      </span>
                    </div>
                    <div className="col-md-4">
                      <span className="text-input">
                        <input
                          name="phone"
                          type="text"
                          placeholder="Phone number"
                          required
                        />
                      </span>
                    </div>
                    <div className="col-md-12">
                      <span className="text-input">
                        <textarea
                          name="message"
                          rows="4"
                          placeholder="Your message"
                          required
                        ></textarea>
                      </span>
                    </div>
                    <div className="col-md-12">
                      <p className="cookies text-center mt-10">
                        <input
                          type="checkbox"
                          name="cookies-consent"
                          id="cookies-consent2"
                        />
                        <label htmlFor="cookies-consent2"></label>I accept the
                        privacy and terms.
                      </p>
                    </div>
                    <div className="col-md-12">
                      <div className="mt-10">
                        <button
                          className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-darkcolor w-100"
                          type="submit"
                        >
                          Make a appointment
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="prt-row client-section clearfix">
        <div className="container-fluid">
          <Slider {...settings} className="prt-client">
            {clients.map((logo, idx) => (
              <div key={idx} className="client-box">
                <div className="client-thumbnail">
                  <a href="#">
                    <img
                      width="280"
                      height="60"
                      className="img-fluid"
                      src={logo}
                      alt={`client-${idx + 1}`}
                    />
                  </a>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </div>
  );
}
